import { render, staticRenderFns } from "./ActorEditDialog.vue?vue&type=template&id=0dab2bba&scoped=true&"
import script from "./ActorEditDialog.vue?vue&type=script&lang=js&"
export * from "./ActorEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dab2bba",
  null
  
)

export default component.exports